"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormStatusListItem = void 0;
const tslib_1 = require("tslib");
const components_1 = require("@bluebase/components");
const react_1 = tslib_1.__importDefault(require("react"));
const FormStatusListItem = ({ children, divider, styles = {}, type, }) => {
    let iconName = '';
    let iconStyles = styles.icon;
    let textStyles = styles.text;
    let rootStyles = Object.assign(Object.assign({}, styles.root), (divider && styles.divider));
    switch (type) {
        case 'error':
            iconName = 'alert-circle';
            iconStyles = Object.assign(Object.assign({}, iconStyles), styles.iconError);
            textStyles = Object.assign(Object.assign({}, textStyles), styles.textError);
            rootStyles = Object.assign(Object.assign({}, rootStyles), styles.dividerError);
            break;
        case 'warning':
            iconName = 'alert';
            iconStyles = Object.assign(Object.assign({}, iconStyles), styles.iconWarning);
            textStyles = Object.assign(Object.assign({}, textStyles), styles.textWarning);
            rootStyles = Object.assign(Object.assign({}, rootStyles), styles.dividerWarning);
            break;
        case 'success':
            iconName = 'check';
            iconStyles = Object.assign(Object.assign({}, iconStyles), styles.iconSuccess);
            textStyles = Object.assign(Object.assign({}, textStyles), styles.textSuccess);
            rootStyles = Object.assign(Object.assign({}, rootStyles), styles.dividerSuccess);
            break;
        default:
            break;
    }
    return (react_1.default.createElement(components_1.View, { style: rootStyles, testID: "FormStatusListitem-View" },
        react_1.default.createElement(components_1.Body2, { style: iconStyles },
            react_1.default.createElement(components_1.Icon, { name: iconName, size: 16 })),
        react_1.default.createElement(components_1.FormattedMessage, { component: components_1.Body2, style: textStyles }, children)));
};
exports.FormStatusListItem = FormStatusListItem;
exports.FormStatusListItem.defaultProps = {
    type: 'error',
};
exports.FormStatusListItem.defaultStyles = (theme) => ({
    root: {
        flexDirection: 'row',
        padding: theme.spacing.unit,
    },
    divider: {
        borderBottomWidth: 1,
    },
    icon: {
        paddingHorizontal: theme.spacing.unit,
    },
    text: {
        flexShrink: 1,
        paddingHorizontal: theme.spacing.unit,
    },
    dividerError: { borderBottomColor: theme.palette.error.main },
    iconError: { color: theme.palette.error.main },
    textError: { color: theme.palette.error.main },
    dividerSuccess: { borderBottomColor: theme.palette.success.main },
    iconSuccess: { color: theme.palette.success.main },
    textSuccess: { color: theme.palette.success.main },
    dividerWarning: { borderBottomColor: theme.palette.warning.dark },
    iconWarning: { color: theme.palette.warning.dark },
    textWarning: { color: theme.palette.warning.dark },
});
